import { IErrorsState } from './state';
import { ITraceableError } from '@/interfaces/Error';

import { EErrorExhibition, EErrorScope } from '@/helpers/enums';
import { isValid } from '@/helpers/values';

export default {
  errorsByExhibitionAndScope: (state: IErrorsState) => {
    return (exhibition: EErrorExhibition, scopes: EErrorScope[] = [EErrorScope.global]) => {
      let errors = state.errors.filter((error: ITraceableError) => {
        return error.exhibition === exhibition;
      });

      if (isValid(scopes)) {
        errors = errors.filter((error: ITraceableError) => {
          return error.scope && scopes.includes(error.scope);
        });
      }

      return isValid(errors) && errors;
    };
  },
};